import { Button, Spinner } from "@motleyhand/design"
import type { ComponentProps, RefObject } from "react"
import type { IconSvgElement } from "@hugeicons/react"
import { HugeiconsIcon } from "@hugeicons/react"

type Props = Omit<ComponentProps<typeof Button>, "size"> & {
  icon: IconSvgElement
  size?: "icon" | "icon-xs" | "icon-sm" | "icon-lg"
  isLoading?: boolean
  ref?: RefObject<HTMLAnchorElement | null>
}

export default function IconButton({
  key,
  icon,
  size = "icon",
  variant = "ghost",
  isLoading,
  ...buttonProps
}: Props) {
  return (
    <Button key={key} size={size} variant={variant} {...buttonProps}>
      {isLoading ? <Spinner /> : <HugeiconsIcon icon={icon} />}
    </Button>
  )
}
